import actions from './companyActions'
import mutations from './companyMutations'

export default {
  namespaced: true,
  actions,
  mutations
}
